import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col } from 'reactstrap';
import { Tooltip } from 'antd';
import { history } from '../../../../../config/history';
import { get } from '../../../../../shared/helpers';
import BlemishIcon from './components/BlemishIcon';

class ApprovalInfo extends Component {
    lead_id = this.props.lead_id || history.location.pathname.slice(-24);

    iconContainerStyles = {
        padding: '10px 0 20px',
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
    };

    iconStylesHandler = (icon) => {
        // default color - grey(#ccc),
        // if rejected/failed - red(#f50)
        // if wait for approval - orange
        // if approved/completed - green(#87d068)
        const iconStyles = {
            fontSize: 30,
            color: '#ccc',
        };

        if (this.props.Leads && this.props.Leads.Lead_profile) {
            if (icon === 'mot' && get(this.props.Lead_mot_history, 'mot_history')) {
                if (this.props.Lead_mot_history.mot_history[0] && this.props.Lead_mot_history.mot_history[0].result === 'PASSED') {
                    iconStyles.color = '#87d068';
                } else if (this.props.Lead_mot_history.mot_history[0] && this.props.Lead_mot_history.mot_history[0].result === 'FAILED') {
                    iconStyles.color = '#f50';
                }
            }
            if (
                icon === 'cap'
                && this.props.Lead_cap_valuation.cap_valuation
                && Object.keys(this.props.Lead_cap_valuation.cap_valuation)
                    .some(
                        (key) => key !== '_id' && this.props.Lead_cap_valuation.cap_valuation[key] !== null,
                    )
            ) {
                iconStyles.color = '#87d068';
            }

            if (icon === 'hpi' && this.props.Lead_general.bike_hpi_check && this.props.lead_approval && this.props.lead_approval.hpi_check) {
                let checkHpiCheckNotFailedExceptFinance = false;
                if (this.props.Lead_general.bike_hpi_check.pass_checks) {
                    checkHpiCheckNotFailedExceptFinance = Object.keys(this.props.Lead_general.bike_hpi_check.pass_checks)
                        .every(
                            (pass_check) => {
                                if (pass_check === 'finance' || pass_check === '_id' || pass_check === 'detail') {
                                    return true;
                                }
                                return this.props.Lead_general.bike_hpi_check.pass_checks[pass_check];
                            },
                        );
                }

                if (this.props.lead_approval.hpi_check.requires_approval) {
                    iconStyles.color = 'orange';
                } else if (this.props.lead_approval.hpi_check.requires_approval === false && this.props.lead_approval.hpi_check.value === true) {
                    iconStyles.color = '#87d068';
                } else if (this.props.lead_approval.hpi_check.requires_approval === false && checkHpiCheckNotFailedExceptFinance) {
                    iconStyles.color = '#87d068';
                } else if (this.props.lead_approval.hpi_check.requires_approval === false && this.props.lead_approval.hpi_check.value === false) {
                    iconStyles.color = '#f50';
                }
            }
            if (icon === 'price' && this.props.lead_approval && this.props.lead_approval.price) {
                if (this.props.lead_approval.price.requires_approval) {
                    iconStyles.color = 'orange';
                } else if (this.props.lead_approval.price.requires_approval === false && this.props.lead_approval.price.value === true) {
                    iconStyles.color = '#87d068';
                } else if (this.props.lead_approval.price.requires_approval === false && this.props.lead_approval.price.value === false) {
                    iconStyles.color = '#f50';
                }
            }
        }
        return iconStyles;
    };

    render() {
        return this.props.Leads && this.props.Leads.Lead_profile
               && (
                   <div className="row">
                       <Col xs={12}>
                           <div style={this.iconContainerStyles}>
                               <Tooltip title="MOT"><span className="fa fa-wrench" style={this.iconStylesHandler('mot')} /></Tooltip>

                               <Tooltip title="CAP"><span className="fa fa-chart-line" style={this.iconStylesHandler('cap')} /></Tooltip>

                               <Tooltip title="BLEMISH"><span><BlemishIcon /></span></Tooltip>

                               <Tooltip title="HPI"><span className="fa fa-clipboard" style={this.iconStylesHandler('hpi')} /></Tooltip>

                               <Tooltip title="PRICE"><span className="fa fa-pound-sign" style={this.iconStylesHandler('price')} /></Tooltip>
                           </div>
                       </Col>
                   </div>
               );
    }
}

const mapStateToProps = (state) => ({
    lead_approval: state.Leads.Lead_profile.Lead_general.approval,
    lead_id: state.Leads.Lead_profile.Lead_general.root_id,
    Leads: state.Leads,
    Lead_general: state.Leads.Lead_profile.Lead_general,
    Lead_cap_valuation: state.Leads.Lead_profile.Lead_cap_valuation,
    Lead_mot_history: state.Leads.Lead_profile.Lead_mot_history,
    valuations: state.Leads.Lead_profile.Lead_valuations.valuations,
});


export default connect(mapStateToProps)(ApprovalInfo);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_table/ApprovalInfo.js